// src/pages/SystemTrigger.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";

const SystemTrigger = () => {
  const [filters, setFilters] = useState({
    fromMonth: "",
    fromYear: new Date().getFullYear(),
    toMonth: "",
    toYear: new Date().getFullYear(),
    location: "",
    frequency: "",
  });

  const [locations, setLocations] = useState([]);
  const [frequencies, setFrequencies] = useState([]);
  const [actionables, setActionables] = useState([]);
  const [loading, setLoading] = useState(false);

  const [username, setUsername] = useState(localStorage.getItem("username") || "");

  // Load logged-in user if username not set
useEffect(() => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    setUsername("");
    return;
  }

  axios
    .get("/api/users/me/", {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      setUsername(res.data.username);
      localStorage.setItem("username", res.data.username);
    })
    .catch((err) => console.error("Failed to load username:", err));
}, []);

  // Load dropdown filters
  useEffect(() => {
    axios
      .get("/api/actionables/filters/")
      .then((res) => {
        setLocations(res.data.locations || []);
        setFrequencies(res.data.frequencies || []);
      })
      .catch((err) => {
        console.error("Error fetching filters:", err);
      });
  }, []);

  // Main function – Loads System Trigger data based on filters
  const fetchSystemTriggers = async () => {
    if (!username) return;

    setLoading(true);
    try {
      const payload = {
        username,
        type: "System Trigger",
        fromMonth: filters.fromMonth,
        fromYear: filters.fromYear,
        toMonth: filters.toMonth,
        toYear: filters.toYear,
        location: filters.location,
        frequency: filters.frequency,
      };

      const token = localStorage.getItem("accessToken");

      const res = await axios.post("/api/actionables/system-trigger/", payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setActionables(res.data.actionables || []);
    } catch (e) {
      console.error("Error loading system triggers:", e);
      setActionables([]);
    } finally {
      setLoading(false);
    }
  };

  // Auto load when username OR filters change
  useEffect(() => {
    if (username) fetchSystemTriggers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username, filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const monthNames = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
  ];

  return (
    <div className="container">
      {/* Header */}
      <div className="header-row">
        <h1 className="header">ISO System Trigger Register</h1>
        <button className="back-button" onClick={() => (window.location.href = "/dashboard")}>
          ⬅ Back to Dashboard
        </button>
      </div>

      {/* Logged-in user */}
      <div style={{ marginBottom: 12 }}>
        <strong>User:</strong>{" "}
        <span style={{ background: "#eef2ff", padding: "4px 8px", borderRadius: 6 }}>
          {username || "Not signed in"}
        </span>
      </div>

      {/* Filters */}
      <div className="filters">
        <div className="filter-item">
          <label>From Month</label>
          <select name="fromMonth" value={filters.fromMonth} onChange={handleFilterChange}>
            <option value="">Select</option>
            {monthNames.map((m, i) => <option key={i} value={i+1}>{m}</option>)}
          </select>
        </div>

        <div className="filter-item">
          <label>From Year</label>
          <input
            type="number"
            name="fromYear"
            value={filters.fromYear}
            onChange={handleFilterChange}
          />
        </div>

        <div className="filter-item">
          <label>To Month</label>
          <select name="toMonth" value={filters.toMonth} onChange={handleFilterChange}>
            <option value="">Select</option>
            {monthNames.map((m, i) => <option key={i} value={i+1}>{m}</option>)}
          </select>
        </div>

        <div className="filter-item">
          <label>To Year</label>
          <input
            type="number"
            name="toYear"
            value={filters.toYear}
            onChange={handleFilterChange}
          />
        </div>

        <div className="filter-item">
          <label>Location</label>
          <select name="location" value={filters.location} onChange={handleFilterChange}>
            <option value="">All</option>
            {locations.map((l) => <option key={l} value={l}>{l}</option>)}
          </select>
        </div>

        <div className="filter-item">
          <label>Frequency</label>
          <select name="frequency" value={filters.frequency} onChange={handleFilterChange}>
            <option value="">All</option>
            {frequencies.map((f) => <option key={f} value={f}>{f}</option>)}
          </select>
        </div>

        <div className="filter-item">
          <button className="apply-button" onClick={fetchSystemTriggers}>
            Apply Filters
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="card">
        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Actionable Number</th>
                  <th>Actionable Name</th>
                  <th>Location</th>
                  <th>Type</th>
                  <th>Category</th>
                  <th>Frequency</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Status</th>
                  <th>Description</th>
                  <th>Owner</th>
                  <th>Policy / Document</th>
                </tr>
              </thead>
              <tbody>
                {actionables.length === 0 ? (
                  <tr>
                    <td colSpan="11" className="no-data">No data found.</td>
                  </tr>
                ) : (
                  actionables.map((a, i) => (
                    <tr key={i}>
                      <td>
                        <a href={`/actionable/${a.uat_id}`} className="link">
                          {a.actionable_number}
                        </a>
                      </td>
                      <td>{a.actionable_name}</td>
                      <td>{a.location}</td>
                      <td>{a.type}</td>
                      <td>{a.category}</td>
                      <td>{a.frequency}</td>
                      <td>{a.start_date}</td>
                      <td>{a.end_date}</td>
                      <td>{a.status}</td>
                      <td>{a.actionable_description}</td>
                      <td>{a.username}</td>
                      <td>{a.policy_or_document_name}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Inline CSS */}
      <style>{`
        .container {
          padding: 20px;
          font-family: Arial, sans-serif;
          background-color: #f5f5f5;
        }

        .header-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
        }

        .header {
          font-size: 28px;
          font-weight: bold;
          color: #333;
        }

        .back-button {
          background-color: #6b7280;
          color: white;
          border: none;
          padding: 8px 12px;
          border-radius: 8px;
          cursor: pointer;
          transition: 0.2s;
        }

        .back-button:hover {
          background-color: #4b5563;
        }

        .filters {
          display: flex;
          flex-wrap: wrap;
          gap: 15px;
          background: #fff;
          padding: 15px;
          border-radius: 15px;
          margin-bottom: 20px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }

        .filter-item {
          display: flex;
          flex-direction: column;
          min-width: 150px;
        }

        .filter-item label {
          margin-bottom: 5px;
          font-weight: 500;
          color: #555;
        }

        .filter-item select,
        .filter-item input {
          padding: 6px 10px;
          border-radius: 8px;
          border: 1px solid #ccc;
        }

        .apply-button {
          background-color: #007bff;
          color: white;
          border: none;
          padding: 8px 12px;
          border-radius: 8px;
          cursor: pointer;
          margin-top: auto;
        }

        .apply-button:hover {
          background-color: #0056b3;
        }

        .card {
          background: #fff;
          padding: 20px;
          border-radius: 15px;
          margin-bottom: 20px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }

        table {
          width: 100%;
          border-collapse: collapse;
        }

        table th,
        table td {
          border: 1px solid #ddd;
          padding: 8px;
          text-align: left;
        }

        table th {
          background: linear-gradient(135deg, #102a71, #2053c3);
          color: white;
          font-weight: 700;
        }

        table tr:nth-child(even) {
          background-color: #f9f9f9;
        }

        .no-data {
          text-align: center;
          padding: 15px;
          font-style: italic;
        }

        .link {
          color: #2053c3;
          text-decoration: none;
        }

        .link:hover {
          color: #102a71;
        }

        .table-wrapper {
          overflow-x: auto;
        }
      `}</style>
    </div>
  );
};

export default SystemTrigger;
